const MAPS_KEY = "AIzaSyCYy9Nt8W-znq7fDY1ZcDi_2qP9UhUbetg";
const CALLBACK_NAME = "__guiaMapsReady";

let mapsPromise = null;

function isMapsReady() {
	return !!(
		typeof window !== "undefined" &&
		window.google &&
		window.google.maps &&
		window.google.maps.Map &&
		window.google.maps.places
	);
}

function waitUntilReady(resolve, reject) {
	let tries = 0;
	const tick = function () {
		if (isMapsReady()) {
			resolve(window.google);
			return;
		}
		tries += 1;
		if (tries > 50) {
			mapsPromise = null;
			reject(new Error("Google Maps no quedó listo"));
			return;
		}
		setTimeout(tick, 100);
	};
	tick();
}

/**
 * Carga la API JS de Maps (places) solo cuando el editor la necesita.
 * Sin loading=async: ese parámetro deja google.maps incompleto en script.onload.
 */
export function loadGoogleMaps() {
	if (typeof window === "undefined") {
		return Promise.reject(new Error("window no disponible"));
	}
	if (isMapsReady()) {
		return Promise.resolve(window.google);
	}
	if (mapsPromise) return mapsPromise;

	mapsPromise = new Promise(function (resolve, reject) {
		const finish = function () {
			waitUntilReady(resolve, reject);
		};

		const previous = window[CALLBACK_NAME];
		window[CALLBACK_NAME] = function () {
			if (typeof previous === "function") {
				try {
					previous();
				} catch (_) {}
			}
			finish();
		};

		const existing = document.querySelector(
			'script[data-guia-maps="1"], script[src*="maps.googleapis.com/maps/api/js"]',
		);
		if (existing) {
			if (existing.readyState === "complete" || existing.getAttribute("data-loaded") === "1") {
				finish();
				return;
			}
			existing.addEventListener("load", finish);
			existing.addEventListener("error", function () {
				mapsPromise = null;
				reject(new Error("Google Maps no se pudo cargar"));
			});
			return;
		}

		const script = document.createElement("script");
		script.setAttribute("data-guia-maps", "1");
		script.src =
			"https://maps.googleapis.com/maps/api/js?key=" +
			MAPS_KEY +
			"&libraries=places&v=quarterly&callback=" +
			CALLBACK_NAME;
		script.async = true;
		script.defer = true;
		script.onload = function () {
			script.setAttribute("data-loaded", "1");
			finish();
		};
		script.onerror = function () {
			mapsPromise = null;
			reject(new Error("Google Maps no se pudo cargar"));
		};
		document.head.appendChild(script);
	});

	return mapsPromise;
}

export { isMapsReady };
